module.exports = __webpack_public_path__ + "media/images/mother-day/motherday-template-ru-44d92d90068ebc11426aaa0634107583.png";